import React, { useState, useEffect } from "react";
import toast, { Toaster } from "react-hot-toast";
import { onMessageListener } from "../../firebase";
import { useDispatch } from "react-redux";
import { setNotificationData } from "../../Redux/Reducers/notifiactionSlice";
import { API } from "../../Services/api-services";

const Notification = () => {
  const [notification, setNotification] = useState({ title: "", body: "" });
  const dispatch = useDispatch();

  const notify = () => toast(<ToastDisplay />);
  function ToastDisplay() {
    return (
      <div>
        <p>
          <b>{notification?.title}</b>
        </p>
        <p>{notification?.body}</p>
      </div>
    );
  }

  useEffect(() => {
    if (notification?.title) {
      notify();
    }
  }, [notification]);

  const getNotifications = () => {
    let params = window.ReactNativeWebView ? "?token="+localStorage.getItem("deviceToken") : "";
    API.get("/fcm/getNotifications"+params)
      .then((res) => {
        if (res && res?.data) {
          dispatch(setNotificationData(res.data));
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  if(!window.ReactNativeWebView) {
    onMessageListener()
      .then((payload) => {
        setTimeout(() => {
          getNotifications();
        }, 5000);
        setNotification({
          title: payload?.data?.title,
          body: payload?.data?.body,
        });
      })
      .catch((err) => console.log("failed: ", err));
  }

  return <Toaster />;
};

export default Notification;
